app.controller('RiskProfillerController', ['$scope', 'WdHttpService', 'sessionService', 'config', '$routeParams', 'analyticsService',
    function ($scope, WdHttpService, sessionService, config, $routeParams, analyticsService) {

        $scope.showResults = false;
        $scope.start_profilling = async function () {
            $scope.showPageLoader();
            await $scope.fetchAdviserSiteDetails();
            if (!sessionService.isQcLoggedIn()) {
                await loginToQc($scope, WdHttpService);
            }
            await $scope.initialize();
            $scope.hidePageLoader();
        }

        $scope.initialize = async function () {
            if ($routeParams.next == 'agreement') {
                $scope.adviserUsername = $routeParams.adviserUsername;
                $scope.redirectTo = '/adviser-agreement/' + $routeParams.adviserUsername + '/' + $routeParams.fundName;
            } else {
                $scope.adviserUsername = $scope.isAdviser ? $scope.distributorUsername : 'quantech';
                $scope.redirectTo = '/fund-discovery';
            }
            $scope.answers = [];
            $scope.questionFlags = [];
            $scope.questions = [];
            await WdHttpService._qc_risk_profile_questions()
                .then(response => {
                    $scope.questions = response;
                    $scope.questionsErrorText = undefined;
                    for (let index = 0; index < response.length; index++) {
                        if (index == 0) {
                            $scope.questionFlags[index] = true;
                        } else {
                            $scope.questionFlags[index] = false;
                        }
                    }
                }).catch(error => {
                    $scope.questionsErrorText = error;
                });
        }

        $scope.goto = function (number) {
            if (number > 0) {
                if ($scope.answers[number - 1] == undefined) {
                    $scope.questionsErrorText = 'You have not answered ' + (number) + ordinal(number) + ' question. Please select a answer';
                    return;
                } else {
                    $scope.questionsErrorText = undefined;
                }
            }

            for (var index = 0; index < $scope.questions.length; index++) {
                if (index == number)
                    $scope.questionFlags[index] = true;
                else
                    $scope.questionFlags[index] = false;
            }
        }

        $scope.submitAnswers = function () {
            $scope.showPageLoader();
            var request = {};
            request.userResponses = [];
            for (var index = 0; index < $scope.questions.length; index++) {
                var question = $scope.questions[index];
                var answer = $scope.answers[index];

                if (answer)
                    request.userResponses.push({
                        'questionText': question.questionText,
                        'response': answer
                    });
                else {
                    $scope.questionsErrorText = 'You have not answered ' + (index + 1) + ordinal(index + 1) + ' question.';
                    // $scope.goto(index);
                    return;
                }
            }
            request.clientCode = sessionService.get('cognito_username') ? sessionService.get('cognito_username') : 'client';
            request.amc = 'WealthDesk Adviser Microsite';
            WdHttpService._qc_risk_profile_submission(request)
                .then(async response => {
                    $scope.results = response.category;
                    $scope.riskLevel = calculateRisk(response);
                    $scope.showResults = true;

                    // Stopped updating cognito profile as discussed.
                    // await WdHttpService._update_cognito_profile('custom:risk', $scope.riskLevel);
                    var data = {
                        "adviserUsername": $scope.adviserUsername,
                        "riskValue": $scope.riskLevel,
                        "riskData": request.userResponses,
                        "riskScore": response.score
                    };
                    await WdHttpService._post_user_risk_profile(data);
                    var eventData = {
                        'adviserUsername': $scope.adviserUsername.toLowerCase()
                    };
                    await analyticsService._push_custom_event_data_to_datalayer('risk-profile-completed', eventData);

                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                }).catch(error => {
                    console.log(error);
                    $scope.questionsErrorText = error;
                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                });
        }

        $scope.setCheckBoxAnswer = function () {
            $scope.answers[4] = getHighestOrderAnswer();
        }

        function getHighestOrderAnswer() {
            var answer3 = document.getElementById("radio_4_2").checked;
            if (answer3)
                return $('#radio_4_2').val();

            var answer2 = document.getElementById("radio_4_1").checked;
            if (answer2)
                return $('#radio_4_1').val();

            var answer1 = document.getElementById("radio_4_0").checked;
            if (answer1)
                return $('#radio_4_0').val();

            return undefined;
        }

        function calculateRisk(response) {
            if (response.score > 3)
                return 'HIGH';
            else if (response.score > 1)
                return 'MEDIUM';

            return 'LOW'
        }

        function ordinal(number) {
            if (number == 1)
                return 'st';
            if (number == 2)
                return 'nd';
            if (number == 3)
                return 'rd';
            return 'th';
        }

        async function loginToQc($scope, WdHttpService) {
            $scope.showPageLoader();
            await WdHttpService._qc_login();
            $scope.hidePageLoader();
        }
    }
]);